import { DateTime } from "luxon";

import { TIMEZONE } from "@/common/constants";

export const formatDate = (value, isUTC = false) => {
    const format = "yyyy-MM-dd";
    if (!value) {
        return "Fecha invalida";
    }

    const date = DateTime.fromJSDate(new Date(value));
    if (isUTC) {
        return date.toUTC().toFormat(format);
    }
    return date.setZone(TIMEZONE).toFormat(format);
};

export const getNowFormatted = (format = "yyyy-MM-dd HH:mm:ss") => {
    return DateTime.now().toFormat(format);
};
